export enum SubscriptionBillingPeriod {
	YEARLY = 'YEARLY',
	MONTHLY = 'MONTHLY',
}

export enum SubscriptionBillingType {
	SUBSCRIPTION = 'SUBSCRIPTION',
	ONE_TIME = 'ONE_TIME',
}

export enum StripeStatus {
	ACTIVE = 'active',
	CANCELED = 'canceled',
	PAST_DUE = 'past_due',
	TRIALING = 'trialing',
	UNPAID = 'unpaid',
	INCOMPLETE = 'incomplete',
	INCOMPLETE_EXPIRED = 'incomplete_expired',
}

export enum UserPilotCustomEvent {
	SAVED_ACCOUNT_INFORMATION = 'SAVED_ACCOUNT_INFORMATION',
	SAVED_OPENING_HOURS = 'SAVED_OPENING_HOURS',
	SAVED_BOOKING_HOURS = 'SAVED_BOOKING_HOURS',
	SAVED_BOOKING_SETTINGS = 'SAVED_BOOKING_SETTINGS',
	CREATED_BOOKING = 'CREATED_BOOKING',
	INVITED_NEW_USER = 'INVITED_NEW_USER',
	CREATED_TABLE = 'CREATED_TABLE',
	COPIED_BOOKING_LINK = 'COPIED_BOOKING_LINK',
	USER_HAS_ADMIN_RIGHTS = 'USER_HAS_ADMIN_RIGHTS',
}

export enum UserPilotCustomFunction {
	GO_TO_ACCOUNT_INFORMATION = '_userpilot_go_to_account_information',
	GO_TO_OPENING_HOURS = '_userpilot_go_to_opening_hours',
	GO_TO_BOOKING_HOURS = '_userpilot_go_to_booking_hours',
	GO_TO_BOOKING_SETTINGS = '_userpilot_go_to_booking_settings',
	GO_TO_BOOKINGS = '_userpilot_go_to_bookings',
	GO_TO_USERS = '_userpilot_go_to_users',
	GO_TO_ROOMS = '_userpilot_go_to_rooms',
}

export enum ECONVERSATIONPARTICIPANTTYPE {
	EMPLOYEES = 'MESSAGES.EMPLOYEES',
	GROUPS = 'MESSAGES.GROUPS',
}

export enum EINTEGRATIONSMODEL {
	USERS = 'users',
	DEPARTMENTS = 'departments',
}

export enum ENOTIFICATIONTYPE {
	TYPE_NEW_MESSAGE = 1,
	TYPE_NEW_MESSAGE_BOARD_POST = 2,
	TYPE_NEW_SHIFT = 3,
	TYPE_DELETED_SHIFT = 4,
	TYPE_EDITED_SHIFT = 5,
	TYPE_NEW_SICK_MESSAGE = 6,
	TYPE_REPLACEMENT_FOR_YOUR_SHIFT = 7,
	TYPE_SHIFT_STOCK_BID_APPROVED = 8,
	TYPE_SHIFT_STOCK_BID_REJECTED = 9,
	TYPE_SICK_MESSAGE_ANOTHER_USER_WAS_SELECTED = 10,
	TYPE_SICK_MESSAGE_REPLACE_FOR_YOUR_SHIFT_FOUND = 11,
	TYPE_SICK_MESSAGE_RESPONSE_APPROVED = 12,
	TYPE_AVAILABILITY_APPROVED = 13,
	TYPE_AVAILABILITY_REJECTED = 14,
	TYPE_SHIFT_STOCK_CHANGE_APPROVED = 15,
	TYPE_NEW_MESSAGE_BOARD_POST_COMMENT = 16,
}

export enum ESICKDAYANSWERTYPE {
	STATUS_CAN_TAKE = 1,
	STATUS_CANNOT_TAKE = 2,
	STATUS_SEEN = 3,
	STATUS_NOT_SEEN = 4,
}

export enum EINTEGRATIONSTATE {
	ACTIVE = 'ACTIVE',
	INACTIVE = 'INACTIVE',
}

export enum ETURNOVERTYPE {
	ACTUAL = 'ACTUAL',
	EXPECTED = 'EXPECTED',
}

export enum ESTATISTICSTACKTYPE {
	GROUP = 'GROUP',
	USER = 'USER',
	DEPARTMENT = 'DEPARTMENT',
}

export enum ESTATISTICSINTERVAL {
	WEEKS = 'WEEKS',
	DAYS = 'DAYS',
	MONTHS = 'MONTHS',
}

export enum EditEmployeeForm {
	Salary = 'salary',
	Details = 'details',
	Areas = 'areas',
	OtherDetails = 'otherDetails',
	Files = 'files',
}

export enum EditPunchClockForm {
	General = 'general',
	RoundingRules = 'roundingRules',
}
